<template>
  <div>
    <!-- read-only mode -->
    <plan-fields :plan="plan" :editMode="false"></plan-fields>
    <service-plans-table
      :servicePlans="servicePlans"
      :editMode="false"
      :canEditAssignments="canEditAssignments"
    ></service-plans-table>
  </div>
</template>

<script>
import PlanFields from "./plan-fields";
import ServicePlansTable from "./service-plans-table";
export default {
  components: { PlanFields, ServicePlansTable },
  props: ["plan", "canEditAssignments"],
  computed: {
    servicePlans() {
      return (this.plan && this.plan.servicePlans) || [];
    },
  },
};
</script>
